export default __webpack_public_path__ + "static/media/yogurtparfait-wide@3x.2145f5b1.jpg";